import { render } from "./index.vue?vue&type=template&id=4e7ddfbd"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/modal/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e7ddfbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7ddfbd', __exports__)) {
    api.reload('4e7ddfbd', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4e7ddfbd", () => {
    api.rerender('4e7ddfbd', render)
  })

}


export default __exports__